import { z } from 'zod';

const draftLineSchema = z.object({
  sourceKey: z.string().min(1),
  sourceType: z.enum(['INVENTORY_STOCK', 'PENDING_ALLOCATION']),
  invStockId: z.string().optional().nullable(),
  pendingAllocationId: z.string().optional().nullable(),
  mtrId: z.string().min(1),
  mtrNo: z.string().optional().nullable(),
  mtrName: z.string().optional().nullable(),
  stockNo: z.string().optional().nullable(),
  availableQty: z.coerce.number().min(0),
  qty: z.coerce.number({
    required_error: '請輸入操作數量',
    invalid_type_error: '操作數量必須為數字',
  }).gt(0, '操作數量必須大於 0'),
}).superRefine((line, ctx) => {
  if (line.sourceType === 'INVENTORY_STOCK' && !line.invStockId) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ['invStockId'],
      message: '缺少庫存來源',
    });
  }
  if (line.sourceType === 'PENDING_ALLOCATION' && !line.pendingAllocationId) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ['pendingAllocationId'],
      message: '缺少待配置來源',
    });
  }
});

export const workOrderOutboundFormSchema = z.object({
  issueDate: z.string().min(1, '請填寫出庫日'),
  issueReason: z.string().optional().nullable(),
  remark: z.string().optional().nullable(),
  lines: z.array(draftLineSchema).min(1, '請至少選用一筆庫存來源'),
}).superRefine((values, ctx) => {
  (values.lines ?? []).forEach((line, index) => {
    const available = Number(line.availableQty) || 0;
    const qty = Number(line.qty) || 0;
    if (qty > available) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['lines', index, 'qty'],
        message: `不可超過可用量 ${available}`,
      });
    }
  });
});

export const WORK_ORDER_OUTBOUND_FIELD_LABELS = {
  issueDate: '出庫日',
  issueReason: '出庫事由',
  remark: '備註',
  lines: '出庫明細',
  'lines.qty': '操作數量',
};

export const DEFAULT_OUTBOUND_FORM_VALUES = {
  issueDate: '',
  issueReason: '',
  remark: '',
  lines: [],
};
